'use strict';

(() => {
  const template = document.createElement('template');

  template.innerHTML = /* html */ `
    <style>
      .container {
        margin: 0 0 20px 0;
      }
    </style>
    
    <div class="container">
      <a class="link-back" href="">
        <slot></slot>
      </a>
    </div>
    `;

  class ButtonBack extends HTMLElement {
    #root = null;
    #linkBack = null;

    constructor() {
      super();
      this.#root = this.attachShadow({ mode: 'closed' });
      this.#root.appendChild(template.content.cloneNode(true));

      this.#linkBack = this.#root.querySelector('.link-back');
    }

    static get observedAttributes() {
      return ['link-back'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'link-back') {
        this.#linkBack.href = newValue;
      }
    }
  }

  customElements.define('button-back', ButtonBack);
})();
